export const timeout = 60000; // eslint-disable-line
